import styles from './LoadingSkeleton.module.css';

type LoadingSkeletonProps = {
  width?: string;
  height?: string;
  className?: string;
  rounded?: boolean;
};

/**
 * Компонент скелетона загрузки
 */
export const LoadingSkeleton = ({
  width = '100%',
  height = '1rem',
  className = '',
  rounded = false,
}: LoadingSkeletonProps) => (
  <div
    className={`${styles.skeleton} ${rounded ? styles.rounded : ''} ${className}`}
    style={{ width, height }}
    aria-hidden="true"
  />
);

/**
 * Скелетон для карточки приглашения
 */
export const InviteCardSkeleton = () => (
  <div className={styles.cardSkeleton}>
    <LoadingSkeleton height="2rem" width="60%" className={styles.title} />
    <LoadingSkeleton height="1.5rem" width="40%" className={styles.subtitle} />
    <div className={styles.meta}>
      <LoadingSkeleton height="1rem" width="30%" />
      <LoadingSkeleton height="1rem" width="50%" />
    </div>
    <div className={styles.content}>
      <LoadingSkeleton height="1rem" />
      <LoadingSkeleton height="1rem" width="80%" />
    </div>
  </div>
);

/**
 * Скелетон для формы
 */
export const FormSkeleton = () => (
  <div className={styles.formSkeleton}>
    <LoadingSkeleton height="1.5rem" width="40%" className={styles.label} />
    <LoadingSkeleton height="3rem" className={styles.input} />
    <LoadingSkeleton height="1.5rem" width="40%" className={styles.label} />
    <LoadingSkeleton height="3rem" className={styles.input} />
    <LoadingSkeleton height="1.5rem" width="40%" className={styles.label} />
    <LoadingSkeleton height="3rem" className={styles.input} />
    <LoadingSkeleton height="3.5rem" width="50%" className={styles.button} />
  </div>
);
